import { apiUrl } from "../lib/api.js";
import { loadPaddle, onCheckoutEvent, type PaddleConfig } from "../lib/billing.js";

/**
 * Where StreamNexa, the Chrome extension, sends someone to pay.
 *
 * A Chrome extension may not load remote scripts, so it cannot open Paddle's
 * checkout itself. It asks the server for a checkout; the server picks the
 * prices, creates the Paddle transaction and hands back a link to this page,
 * which only opens that transaction. Nothing here chooses what is sold or
 * whether a trial applies, and nothing here grants access: the webhook does,
 * once Paddle has actually taken the card.
 *
 * Reached at `#/checkout?txn=...`. Works signed out -- the transaction already
 * belongs to the account that asked for it.
 */
export async function extCheckoutView(root: HTMLElement, txn: string) {
  const say = (title: string, body: string) => {
    root.innerHTML = `<section class="card"><h2></h2><p class="meta"></p></section>`;
    root.querySelector("h2")!.textContent = title;
    root.querySelector("p")!.textContent = body;
  };

  if (!/^txn_[a-z0-9]+$/i.test(txn)) {
    say("That checkout link is incomplete", "Start again from Billing & Plans in StreamNexa.");
    return;
  }

  say("Opening the StreamNexa checkout…", "Payments are handled by Paddle, our reseller. Your card details never reach StreamNexa or Stream-Cut.");
  try {
    const cfg = (await (await fetch(apiUrl("/v1/billing/paddle-public"))).json()) as Pick<
      PaddleConfig,
      "client_token" | "environment"
    >;
    onCheckoutEvent((e) => {
      if (e.name === "checkout.completed") {
        say(
          "You're all set",
          "Paddle has your payment details. StreamNexa updates within a few seconds -- you can close this tab.",
        );
      }
    });
    const P = await loadPaddle({ ...cfg, prices: {}, customer: { email: "" }, custom_data: { user_id: "" } });
    P.Checkout.open({ transactionId: txn, settings: { displayMode: "overlay", theme: "dark" } });
  } catch (err) {
    say("The checkout couldn't open", err instanceof Error ? err.message : String(err));
  }
}
